import type { MechKey } from './keys';

export const id: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mekanika · 2D',
  'panel.scene': 'Adegan',
  'panel.dims': 'Parameter',
  'panel.style': 'Tampilan',
  'panel.action': 'Kontrol',
  'style.body': 'Benda',
  'style.vector': 'Vektor',
  'style.ground': 'Tanah',
  'style.forces': 'Tampilkan gaya',
  'style.trace': 'Tampilkan jejak',
  'style.labels': 'Label vektor',
  'hint.line1': 'Klik putar untuk mulai · seret benda untuk memindahkannya',
  'hint.line2': 'Sandbox: pilih bentuk, lalu klik untuk menempatkannya',
  'scene.incline': 'Bidang miring',
  'scene.projectile': 'Gerak peluru',
  'scene.pendulum': 'Pendulum',
  'scene.springMass': 'Sistem pegas-massa',
  'scene.collisions': 'Tumbukan',
  'scene.atwood': 'Mesin Atwood',
  'scene.circular': 'Gerak melingkar',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'sudut (°)',
  'dim.friction': 'gesekan',
  'dim.mass': 'massa',
  'dim.massA': 'massa A',
  'dim.massB': 'massa B',
  'dim.velocity': 'kecepatan',
  'dim.angleLaunch': 'sudut peluncuran (°)',
  'dim.gravity': 'gravitasi',
  'dim.gravityX': 'gravitasi x',
  'dim.gravityY': 'gravitasi y',
  'dim.length': 'panjang',
  'dim.damping': 'redaman',
  'dim.spring': 'kekakuan',
  'dim.restitution': 'restitusi',
  'dim.radius': 'jari-jari',
  'dim.speed': 'laju',
  'action.play': 'Putar',
  'action.pause': 'Jeda',
  'action.step': 'Langkah',
  'action.reset': 'Atur ulang',
  'action.speed': 'Kecepatan',
  'action.clear': 'Hapus',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Gravitasi',
  'forceName.normal': 'Gaya normal',
  'forceName.friction': 'Gaya gesek',
  'forceName.tension': 'Tegangan',
  'forceName.spring': 'Gaya pegas',
  'forceName.applied': 'Gaya terapan',
  'forceName.air': 'Hambatan udara',
  'palette.box': 'Kotak',
  'palette.circle': 'Bola',
  'palette.ramp': 'Tanjakan',
  'palette.ground': 'Tanah',
  'palette.hint': 'Pilih bentuk, lalu klik pada kanvas untuk menempatkannya.',
  'panel.forces': 'Gaya yang terlihat',
  'forces.empty': 'Belum ada — putar adegan',
};
